import { render, staticRenderFns } from "./addOrEditProvider.vue?vue&type=template&id=e2b662be&scoped=true"
import script from "./addOrEditProvider.vue?vue&type=script&lang=js"
export * from "./addOrEditProvider.vue?vue&type=script&lang=js"
import style0 from "./addOrEditProvider.vue?vue&type=style&index=0&id=e2b662be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b662be",
  null
  
)

export default component.exports